<div class="w-full h-16 pr-5 flex flex-row items-center bg-neutral-900">
  <div class="flex-1 flex flex-row items-center">
    <app-internal-menu-button class="mr-5"></app-internal-menu-button>
    @if (title) {
      <span class="font-bold text-lg">{{ title }}</span>
    }
    <ng-content select="[title]"></ng-content>
  </div>

  <div class="flex flex-row items-center">
    <ng-content select="[center]"></ng-content>
  </div>

  <div class="flex-1 flex flex-row items-center">
    @if (actionsDiv.children.length > 0) {
      <div class="ml-auto h-1/2 mr-5 w-px bg-neutral-800"></div>
    }
    <div class="flex flex-row gap-2" #actionsDiv>
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
